import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

const authLayout = () => {
  return (
    <div className="d-block">
    {/* <div className="d-flex flex-column min-vh-100"> */}
      {/* <Header /> */}
      <main className="main-content">
        <Outlet />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default authLayout;
